import { Component, EventEmitter, Query, ViewChild, Output, Input, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { steppedFly, featuresBox, CartOverlay } from '../../../store/animations';
import { Http, Response, Headers } from '@angular/http';
import { Angulartics2 } from 'angulartics2';
import { UserService } from '../../../services/user.service';
import { StoreService } from '../../../services/store.service';
import { environment } from '../../../environment';

// Products
import { Account } from '../../../models/account';
import { Claim } from '../../../models/claim';
import { Order } from '../../../models/order';
import { Product } from '../../../models/product';
import { News } from '../../../models/news';
import { Item } from '../../../models/item';

import { Filter } from '../../../models/filter.constructor';

declare var $: any

@Component({
  selector: 'checkout-thanks', 
  templateUrl: './checkout.thankyou.html',
  providers: [ UserService, StoreService ],
  animations: [ featuresBox, CartOverlay, steppedFly ]
})
export class CheckoutThankyouComponent implements OnInit {

	orders: Order;
	products: Product;
	items: Item;

	// Checkout Variables
	environment = environment;
	title: any;
	header: any;
	subtitle: string;
	hasPassport: boolean;
	headerHeight: any;

	constructor(	private storeService: StoreService,
					private userService: UserService,
					private route: ActivatedRoute,
					private sanitizer: DomSanitizer,
					private router: Router,
					private track: Angulartics2) {
	}

	getOrderDetails() {

		Promise.resolve( this.storeService.getOrder() ).then( (order) => {
			this.orders = order;
		}).catch(function (err) {
		});

 	}




	/* On with the show */
	ngOnInit() {

		// Page defaults
		this.title = 'THANK YOU';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-faq.jpg")' );
		this.subtitle = 'Changing what it means to be an MMORPG.';
		this.headerHeight = '350px';

		this.getOrderDetails();

	}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/checkout/thankyou/checkout.thankyou.ts